import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { DateUtils } from '../../dialogs/calendar-week-picker/date-utils';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { HeimtiereService } from '../heimtiere.service';
import { HeimtierKalenderEintrag, HeimtierKalenderEintragOutput } from '../kalender/heimtier-kalender-eintrag';
import { KalenderEintragDialogComponent } from '../kalender/kalender-eintrag-dialog/kalender-eintrag-dialog.component';
import { NotizDialogComponent } from './notiz-dialog/notiz-dialog.component';
import { EnterValueDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import {
    EnterValue,
    EnterValueInput,
    EnterValueResponse,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import { ZuWartezimmerVerschiebenDialogComponent } from './zu-wartezimmer-verschieben-dialog/zu-wartezimmer-verschieben-dialog.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'kiene-heimtiere-startseite',
    templateUrl: './heimtiere-startseite.component.html',
    styleUrls: ['./heimtiere-startseite.component.scss'],
})
export class HeimtiereStartseiteComponent implements OnInit {
    plannedData: HeimtierKalenderEintrag[] = [];
    waitingRoomData: HeimtierKalenderEintrag[] = [];
    inTreatmentData: HeimtierKalenderEintrag[] = [];
    readyForPaymentData: HeimtierKalenderEintrag[] = [];
    plannedDay: Date;
    loadPlanned = false;
    subPlanned: Subscription;

    constructor(
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly dialog: MatDialog,
        private readonly router: Router,
        private readonly heimtierService: HeimtiereService,
    ) {}

    ngOnInit(): void {
        this.aktualisieren();
    }

    public aktualisieren() {
        this.plannedDay = new Date();
        this.plannedDay.setHours(0, 0, 0, 0);
        this.getPlannedData();
        this.getWaitingRoomData();
        this.getInTreatmentData();
        this.getReadyForPaymentData();
    }

    public changeBackToWartezimmer(event: HeimtierKalenderEintrag) {
        event.behandlungsraum_id = 0;
        this.changeToWartezimmer(event);
    }

    public changeToWartezimmer(event: HeimtierKalenderEintrag): void {
        console.log('changeToWartezimmer', event);
        this.dialog
            .open(NotizDialogComponent, { data: event })
            .afterClosed()
            .subscribe({
                next: value => {
                    if (value) {
                        console.log('changeToWartezimmer', value);
                        event = value;
                        const entity = {
                            hk_id: event.hk_id,
                            notiz: event?.notiz,
                            behandlungsraum_id: event.behandlungsraum_id,
                            ht_beleg_id: event.ht_beleg_id,
                        };
                        this.api
                            .post(this.apiBaseUrl + 'heimtier_kalendereintrag/in_wartezimmer.php', entity)
                            .subscribe({
                                next: () => {
                                    this.getPlannedData();
                                    this.getWaitingRoomData();
                                    this.getInTreatmentData();
                                },
                                error: err => {
                                    this.messageService.errorMessage('Fehler beim Wechseln des Status', err);
                                },
                            });
                    }
                },
            });
    }

    public changeToBehandlung(event: HeimtierKalenderEintrag, short?: boolean): void {
        this.dialog
            .open(ZuWartezimmerVerschiebenDialogComponent, { data: event, width: '50%' })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result?.ok && result?.confirmed) {
                        if (event?.behandlungsraum_id !== result?.behandlungsraum_id) {
                            event.behandlungsraum_id = result?.behandlungsraum_id;
                            this.postToBehandlung(event);
                        }
                    }
                },
            });
    }

    private postToBehandlung(event: HeimtierKalenderEintrag, short?: boolean) {
        this.api.post(this.apiBaseUrl + 'heimtier_kalendereintrag/in_behandlung.php', event).subscribe({
            next: result => {
                if (!short) {
                    this.getWaitingRoomData();
                    this.getInTreatmentData();
                } else {
                    console.log('changeToBehandlung', result);
                }
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Wechseln des Status', err);
            },
        });
    }

    public gotoBeleg(event: HeimtierKalenderEintrag): void {
        if (event?.ht_beleg_id) {
            this.router.navigate(['heimtiere', 'belege', event?.ht_beleg_id]).then();
        }
    }

    public addEntry(): void {
        const item = new HeimtierKalenderEintrag();
        if (this.plannedDay) {
            item.von = new Date(this.plannedDay);
            item.bis = new Date(this.plannedDay);
        } else {
            item.von = new Date();
            item.bis = new Date(new Date().setMinutes(new Date().getMinutes() + 30));
        }

        this.dialog
            .open(KalenderEintragDialogComponent, { data: item, width: '50%' })
            .afterClosed()
            .subscribe({
                next: (value: HeimtierKalenderEintragOutput) => {
                    if (value?.confirm) {
                        this.getPlannedData();
                    }
                },
            });
    }

    public editEntry(item: HeimtierKalenderEintrag): void {
        this.dialog
            .open(KalenderEintragDialogComponent, { data: item, width: '50%' })
            .afterClosed()
            .subscribe({
                next: (value: HeimtierKalenderEintragOutput) => {
                    if (value?.confirm) {
                        this.getPlannedData();
                    }
                },
            });
    }

    public onDelete(entry: HeimtierKalenderEintrag): void {
        const data = { title: 'Termin löschen', text: 'Soll der Termin wirklich gelöscht werden?' };

        this.dialog
            .open(ConfirmDeleteDialogComponent, { data: data })
            .afterClosed()
            .subscribe({
                next: value => {
                    if (value) {
                        this.api
                            .deleteEntity(this.apiBaseUrl + 'heimtier_kalendereintrag/delete.php', entry)
                            .subscribe({
                                next: () => {
                                    this.getPlannedData();
                                },
                                error: err => {
                                    this.messageService.errorMessage('Eintrag konnte nicht gelöscht werden!', err);
                                },
                            });
                    }
                },
            });
    }

    public getTiernamen(item: HeimtierKalenderEintrag): string {
        if (!item?.tiere || item?.tiere?.length == 0) {
            return '(kein Tier)';
        }
        let result = '';
        for (let tier of item?.tiere) {
            if (result != '') {
                result += ', ';
            }
            result += tier?.name;
        }
        return '(' + result + ')';
    }

    rechnungErstellen(item: HeimtierKalenderEintrag) {
        this.api
            .get(
                this.apiBaseUrl + 'heimtier_beleg/read_one.php',
                new HttpParams().set('ht_beleg_id', item?.ht_beleg_id),
            )
            .subscribe({
                next: response => {
                    this.heimtierService.rechnungErstellen(response);
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Laden des Belegs', err);
                },
            });
    }

    private getPlannedData(): void {
        this.loadPlanned = true;
        this.plannedData = [];

        const von = DateUtils.dateToYYYYMMDD(this.plannedDay);
        const nextDay = new Date(this.plannedDay);
        nextDay.setDate(this.plannedDay.getDate() + 1);
        const bis = DateUtils.dateToYYYYMMDD(nextDay);

        const param = new HttpParams().set('von', von).set('bis', bis).set('status_id', '211').set('orderby', 'bis');

        this.subPlanned?.unsubscribe();
        this.subPlanned = this.api.getAll(this.apiBaseUrl + 'heimtier_kalendereintrag/read.php', param).subscribe({
            next: data => {
                this.plannedData = data.records;
                this.loadPlanned = false;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der Daten', err);
                this.loadPlanned = false;
            },
        });
    }

    private getInTreatmentData(): void {
        let param = new HttpParams();
        param = param.set('status_id', 213);
        param = param.set('orderby', 'hk.editiert desc');

        this.api.getAll(this.apiBaseUrl + 'heimtier_kalendereintrag/read.php', param).subscribe({
            next: data => {
                this.inTreatmentData = data.records;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der Daten', err);
            },
        });
    }

    private getWaitingRoomData(): void {
        let param = new HttpParams();
        param = param.set('status_id', 212);
        param = param.set('orderby', 'wartezimmer_seit');
        this.api.getAll(this.apiBaseUrl + 'heimtier_kalendereintrag/read.php', param).subscribe({
            next: data => {
                this.waitingRoomData = data.records;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der Daten', err);
            },
        });
    }

    private getReadyForPaymentData(): void {
        let param = new HttpParams();
        param = param.set('status_id', 214);
        param = param.set('orderby', 'hk.editiert desc');

        this.api.getAll(this.apiBaseUrl + 'heimtier_kalendereintrag/read.php', param).subscribe({
            next: data => {
                this.readyForPaymentData = data.records;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der Daten', err);
            },
        });
    }

    public previousDay(): void {
        this.plannedDay = new Date(this.plannedDay);
        this.plannedDay.setDate(this.plannedDay.getDate() - 1);
        this.getPlannedData();
    }

    public nextDay(): void {
        this.plannedDay = new Date(this.plannedDay);
        this.plannedDay.setDate(this.plannedDay.getDate() + 1);
        this.getPlannedData();
    }

    openDayPickerDialog() {
        const input = new EnterValueInput();
        input.title = 'Tag auswählen';
        input.text = 'Bitte Tag auswählen';
        const ev = new EnterValue();
        ev.value = new Date(this.plannedDay);
        ev.type = 'date';
        input.values.push(ev);

        this.dialog
            .open(EnterValueDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (value: EnterValueResponse) => {
                    if (value?.result) {
                        this.plannedDay = new Date(value.getValue(0));
                        this.plannedDay.setHours(0, 0, 0, 0);
                        this.getPlannedData();
                    }
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Laden der Daten', err);
                },
            });
    }

    direktBelegErstellen() {
        let hke = new HeimtierKalenderEintrag();
        hke.von = new Date();
        hke.bis = new Date(new Date().setMinutes(new Date().getMinutes() + 30));

        this.dialog
            .open(KalenderEintragDialogComponent, { data: hke, width: '50%' })
            .afterClosed()
            .subscribe({
                next: (value: HeimtierKalenderEintragOutput) => {
                    if (value?.confirm) {
                        hke = value?.heimtierKalenderEintrag;
                        this.api.post(this.apiBaseUrl + 'heimtier_beleg/short_create.php', hke).subscribe({
                            next: result => {
                                if (result?.ht_beleg_id) {
                                    this.router.navigate(['heimtiere', 'belege', result?.ht_beleg_id]).then();
                                }
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler beim Erstellen des Belegs', err);
                            },
                        });
                    }
                },
            });
    }
}
